import { InstagramCard } from 'components/InstagramCard/InstagramCard';
import blackInstagram from 'images/icons/blackInstagram.svg';
import instagramImage1 from 'images/instagramImage1.png';
import instagramImage2 from 'images/instagramImage2.jpg';
import instagramImage3 from 'images/instagramImage3.png';
import instagramImage4 from 'images/instagramImage4.jpg';
import './styles.scss';

const Instagram = () => (
    <section>
        <div className="container">
            <div className="instagram-news">
                <div className="instagram-image-wrapper">
                    <h1>Follow our news on Instagram</h1>
                    <img src={blackInstagram} alt="instagram" />
                </div>
                <div className="first-instagram-card">
                    <InstagramCard image={instagramImage1} />
                </div>
                <div className="second-instagram-card">
                    <InstagramCard image={instagramImage2} />
                </div>
                <div className="third-instagram-card">
                    <InstagramCard image={instagramImage3} />
                </div>
                <div className="fourth-instagram-card">
                    <InstagramCard image={instagramImage4} />
                </div>
            </div>
        </div>
    </section>
);

export default Instagram;
